// Central content/data for Arena Movement Physiotherapy

export const CLINIC = {
  name: "Arena Movement Physiotherapy",
  tagline: "Move Better. Recover Faster.",
  phone: "0414 606 084",
  phoneIntl: "+61414606084",
  email: "Vincent_Arena@arenaphysiotherapy.com",
  address: "1A Sydenham Street, Sandringham VIC 3191",
  suburb: "Sandringham & Highett, Melbourne",
  rating: 5.0,
  reviewCount: 1,
  hours: [
    { day: "Monday", time: "9:00 am – 5:00 pm", open: true },
    { day: "Tuesday", time: "Closed", open: false },
    { day: "Wednesday", time: "Closed", open: false },
    { day: "Thursday", time: "Closed", open: false },
    { day: "Friday", time: "Closed", open: false },
    { day: "Saturday", time: "Closed", open: false },
    { day: "Sunday", time: "Closed", open: false },
  ],
  socials: [
    { label: "Instagram", icon: "instagram", url: "https://www.instagram.com/arena_movement_physio/" },
  ],
};

export const PRICING = [
  {
    id: "follow-up",
    category: "Consultation",
    name: "Follow-up Appointment",
    duration: "30 mins",
    price: "$100.00",
    description: "30-minute follow up consultation to progress your recovery plan.",
  },
  {
    id: "initial",
    category: "Consultation",
    name: "Initial Consultation",
    duration: "45 mins",
    price: "$130.00",
    description: "Initial 45-minute consultation including assessment and treatment of one injury.",
  },
  {
    id: "massage",
    category: "Massage",
    name: "Remedial Massage",
    duration: "20 mins",
    price: "$80.00",
    description: "Remedial massage of up to 2 body parts.",
  },
];

const IMG = {
  hero: "https://images.pexels.com/photos/20860610/pexels-photo-20860610.jpeg?auto=compress&cs=tinysrgb&w=1600",
  legTherapy: "https://images.pexels.com/photos/20860592/pexels-photo-20860592.jpeg?auto=compress&cs=tinysrgb&w=1200",
  athlete: "https://images.pexels.com/photos/20860625/pexels-photo-20860625.jpeg?auto=compress&cs=tinysrgb&w=1200",
  gymRecovery: "https://images.pexels.com/photos/27730474/pexels-photo-27730474.jpeg?auto=compress&cs=tinysrgb&w=1200",
  kneeEms: "https://images.pexels.com/photos/30483052/pexels-photo-30483052.jpeg?auto=compress&cs=tinysrgb&w=1200",
  kneeMassage: "https://images.pexels.com/photos/20860607/pexels-photo-20860607.jpeg?auto=compress&cs=tinysrgb&w=1200",
  massage: "https://images.pexels.com/photos/5794025/pexels-photo-5794025.jpeg?auto=compress&cs=tinysrgb&w=1200",
  clinic: "https://images.pexels.com/photos/5827294/pexels-photo-5827294.jpeg?auto=compress&cs=tinysrgb&w=1200",
};

export const IMAGES = IMG;

export const TEAM = [
  {
    slug: "vincent",
    name: "Vincent Arena",
    role: "Principal Physiotherapist",
    image: "https://customer-assets.emergentagent.com/job_active-recovery-4/artifacts/urfeh0u5_WhatsApp%20Image%202026-06-27%20at%204.08.33%20PM.jpeg",
    imgPos: "42% 58%",
    zoom: 1.5,
    credentials: "Doctor of Physiotherapy, University of Melbourne",
    bio: "Vincent founded Arena Movement to bring evidence-based, movement-first physiotherapy to active people across Melbourne. He completed his Doctor of Physiotherapy at the University of Melbourne and, with a background in strength and conditioning, blends hands-on treatment with progressive exercise rehabilitation. Vincent is a member of the Australian Physiotherapy Association (APA) and is passionate about helping clients move confidently and return to the activities they love.",
    specialties: ["Sports Injuries", "Strength & Conditioning", "Dry Needling", "Post-operative Rehab"],
  },
];

export const SERVICES = [
  {
    slug: "sports-injuries",
    seoTitle: "Sports Injury Physiotherapy Sandringham",
    seoDescription: "Sports injury physiotherapy in Sandringham. Assessment, treatment and sport-specific rehabilitation for strains, sprains, tendon and ligament injuries at Arena Movement Physiotherapy.",
    title: "Sports Injuries",
    short: "Get back in the game faster with sport-specific assessment and rehab.",
    image: IMG.athlete,
    icon: "trophy",
    overview:
      "Whether you're a weekend warrior or competing at a high level, our physiotherapists diagnose the root cause of your sports injury and build a progressive plan to return you to peak performance, safely.",
    conditions: ["Hamstring & calf strains", "Ankle sprains", "Tennis & golfer's elbow", "ACL & ligament injuries", "Tendinopathies", "Overuse injuries"],
    outcomes: ["Faster, structured return to sport", "Reduced re-injury risk", "Improved strength & movement capacity", "Sport-specific conditioning"],
    faqs: [
      { q: "How soon should I see a physio after a sports injury?", a: "As early as possible. Early assessment helps rule out serious injury, manage swelling and pain, and start the right rehab to speed up recovery." },
      { q: "Will I need a scan?", a: "Most injuries can be diagnosed clinically. We only refer for imaging when it will change your management plan." },
    ],
  },
  {
    slug: "back-neck-pain",
    seoTitle: "Back & Neck Pain Physiotherapy Sandringham",
    seoDescription: "Physiotherapy for back and neck pain in Sandringham. Hands-on treatment and targeted exercise for lower back pain, sciatica, neck stiffness and headaches.",
    title: "Back & Neck Pain",
    short: "Relief from acute and persistent spinal pain with lasting results.",
    image: IMG.legTherapy,
    icon: "spine",
    overview:
      "Back and neck pain are among the most common reasons people see a physio. We identify the contributing factors, including posture, load, strength and lifestyle, and combine hands-on therapy with targeted exercise to give you lasting relief.",
    conditions: ["Lower back pain", "Sciatica", "Disc-related pain", "Neck stiffness & headaches", "Postural pain", "Whiplash"],
    outcomes: ["Reduced pain & stiffness", "Improved mobility", "Confidence to move & lift", "Strategies to prevent flare-ups"],
    faqs: [
      { q: "Is rest the best thing for back pain?", a: "Usually not. Gentle, guided movement is one of the most effective treatments for most back pain. We'll show you what's safe." },
      { q: "How many sessions will I need?", a: "Many people feel better within a few sessions. We tailor a plan and review your progress regularly." },
    ],
  },
  {
    slug: "shoulder-injuries",
    seoTitle: "Shoulder Physiotherapy Sandringham",
    seoDescription: "Shoulder injury physiotherapy in Sandringham. Treatment for rotator cuff injuries, frozen shoulder, impingement and post-surgical shoulders to restore pain-free movement.",
    title: "Shoulder Injuries",
    short: "Restore pain-free strength and range in your shoulder.",
    image: IMG.gymRecovery,
    icon: "activity",
    overview:
      "The shoulder is a complex joint that responds extremely well to targeted physiotherapy. We assess the rotator cuff, joint and surrounding muscles to restore strength, control and pain-free movement overhead.",
    conditions: ["Rotator cuff injuries", "Frozen shoulder", "Shoulder impingement", "Dislocations & instability", "Bursitis", "Post-surgical shoulders"],
    outcomes: ["Pain-free overhead movement", "Restored strength & stability", "Return to gym & sport", "Reduced reliance on pain relief"],
    faqs: [
      { q: "Do I need surgery for a rotator cuff injury?", a: "Many rotator cuff injuries respond very well to physiotherapy without surgery. We'll guide you on the best path for your situation." },
      { q: "Why does my shoulder hurt at night?", a: "Night pain is common with shoulder conditions. Targeted treatment and load management usually improve sleep within a few weeks." },
    ],
  },
  {
    slug: "knee-pain",
    seoTitle: "Knee Pain Physiotherapy Sandringham",
    seoDescription: "Knee pain physiotherapy in Sandringham. Diagnosis and treatment of runner's knee, ligament and meniscus injuries, patellar tendinopathy and knee osteoarthritis.",
    title: "Knee Pain",
    short: "Diagnose and treat knee pain so you can move with confidence.",
    image: IMG.kneeMassage,
    icon: "footprints",
    overview:
      "From runner's knee to ligament injuries and osteoarthritis, we get to the cause of your knee pain. Our combination of manual therapy and tailored strengthening helps you walk, run and squat without pain.",
    conditions: ["Patellofemoral (runner's) pain", "Ligament & meniscus injuries", "Patellar tendinopathy", "Knee osteoarthritis", "ITB syndrome", "Post-surgical knees"],
    outcomes: ["Reduced pain on stairs & squatting", "Improved knee strength & control", "Return to running & sport", "Long-term joint health"],
    faqs: [
      { q: "Can physio help knee arthritis?", a: "Yes. Strengthening and load management are first-line, evidence-based treatments for knee osteoarthritis and can significantly reduce pain." },
      { q: "Should I keep running with knee pain?", a: "Often you can keep running with the right modifications. We'll help you stay active while you recover." },
    ],
  },
  {
    slug: "post-operative-rehabilitation",
    seoTitle: "Post-Operative Rehab Physiotherapy Sandringham",
    seoDescription: "Post-operative rehabilitation in Sandringham. Surgeon-aligned physiotherapy after ACL reconstruction, joint replacements and shoulder surgery to rebuild strength and confidence.",
    title: "Post-operative Rehabilitation",
    short: "Structured, surgeon-aligned rehab to maximise your recovery.",
    image: IMG.legTherapy,
    icon: "stethoscope",
    overview:
      "Recovering from surgery requires a carefully staged plan. We work alongside your surgeon's protocol to rebuild strength, range and confidence, progressing you safely from early recovery all the way back to full activity.",
    conditions: ["ACL reconstruction", "Knee & hip replacements", "Shoulder reconstructions", "Arthroscopy recovery", "Fracture rehabilitation", "Tendon repairs"],
    outcomes: ["Safe, staged progression", "Restored strength & range", "Confidence returning to activity", "Surgeon-aligned milestones"],
    faqs: [
      { q: "When should post-op rehab start?", a: "Often within days of surgery, depending on your surgeon's protocol. Early, appropriate rehab leads to better outcomes." },
      { q: "Do you communicate with my surgeon?", a: "We align your rehab with your surgeon's protocol and can liaise with their rooms when needed." },
    ],
  },
  {
    slug: "workcover",
    seoTitle: "WorkCover Physiotherapy Sandringham",
    seoDescription: "WorkCover physiotherapy in Sandringham. Supportive, evidence-based care and return-to-work programs for workplace injuries at Arena Movement Physiotherapy.",
    title: "WorkCover",
    short: "Supportive, evidence-based care to help you return to work.",
    image: IMG.clinic,
    icon: "briefcase",
    overview:
      "We support WorkCover clients through every stage of recovery. Our goal is a safe and sustainable return to work, with clear communication between you, your employer and your case manager.",
    conditions: ["Workplace strains & sprains", "Repetitive strain injuries", "Lifting injuries", "Manual handling injuries", "Return-to-work programs"],
    outcomes: ["Safe return-to-work plan", "Clear progress reporting", "Reduced pain & improved function", "Coordinated care team"],
    faqs: [
      { q: "Do you accept WorkCover claims?", a: "Yes. With an accepted claim and referral, your physiotherapy may be covered. Contact us and we'll guide you through the process." },
      { q: "Will you communicate with my case manager?", a: "Absolutely. We provide regular updates and reporting to support your claim and recovery." },
    ],
  },
  {
    slug: "ndis",
    seoTitle: "NDIS Physiotherapy Sandringham",
    seoDescription: "NDIS physiotherapy in Sandringham for self-managed and plan-managed participants. Movement-based programs to build strength, mobility and independence.",
    title: "NDIS",
    short: "Movement-focused physiotherapy for NDIS participants.",
    image: IMG.gymRecovery,
    icon: "heart-handshake",
    overview:
      "We provide physiotherapy for self-managed and plan-managed NDIS participants. Our movement-based approach helps you build strength, mobility and independence in a supportive environment.",
    conditions: ["Mobility & strength goals", "Neurological conditions", "Chronic pain management", "Functional capacity building", "Falls prevention"],
    outcomes: ["Greater independence & function", "Improved strength & mobility", "Goal-focused programs", "Supportive, inclusive care"],
    faqs: [
      { q: "Which NDIS participants can you see?", a: "We currently support self-managed and plan-managed participants. Get in touch and we'll confirm the details." },
      { q: "Can you help with my NDIS goals?", a: "Yes, we build programs around your specific functional and movement goals." },
    ],
  },
  {
    slug: "dry-needling",
    seoTitle: "Dry Needling Sandringham",
    seoDescription: "Dry needling in Sandringham. Targeted relief for muscle tightness, trigger points, tension headaches and persistent muscle pain at Arena Movement Physiotherapy.",
    title: "Dry Needling",
    short: "Targeted relief for muscle tightness, trigger points and pain.",
    image: IMG.kneeEms,
    icon: "syringe",
    overview:
      "Dry needling uses fine acupuncture needles to release tight, painful muscle trigger points. Combined with the rest of your treatment plan, it can quickly reduce pain and improve movement.",
    conditions: ["Muscle trigger points", "Tension headaches", "Neck & shoulder tightness", "Calf & hamstring tightness", "Persistent muscle pain"],
    outcomes: ["Reduced muscle tension", "Improved range of movement", "Short-term pain relief", "Better response to exercise"],
    faqs: [
      { q: "Does dry needling hurt?", a: "Most people feel only a small prick and a deep muscle ache or twitch. It's generally very well tolerated." },
      { q: "Is dry needling the same as acupuncture?", a: "They use similar needles but dry needling targets muscular trigger points based on modern anatomy and pain science." },
    ],
  },
  {
    slug: "exercise-rehabilitation",
    seoTitle: "Exercise Rehabilitation Sandringham",
    seoDescription: "Exercise rehabilitation in Sandringham. Individualised, progressive programs to build strength, mobility and resilience and prevent re-injury.",
    title: "Exercise Rehabilitation",
    short: "Progressive, individualised exercise to build lasting resilience.",
    image: IMG.athlete,
    icon: "dumbbell",
    overview:
      "Exercise is medicine. We design individualised, progressive programs that build the strength, mobility and capacity you need to recover fully and stay injury-free for the long term.",
    conditions: ["Strength & mobility deficits", "Return-to-sport programs", "Chronic pain management", "Injury prevention", "General conditioning"],
    outcomes: ["Stronger, more resilient body", "Reduced re-injury risk", "Improved performance", "Confidence in movement"],
    faqs: [
      { q: "Do I need a gym membership?", a: "No. We tailor programs to your environment, whether clinic, home or gym, with the equipment you have access to." },
      { q: "How is this different from a personal trainer?", a: "Our programs are clinically designed for your injury and goals, then progressed by a physiotherapist as you recover." },
    ],
  },
];

export const REVIEWS = [
  {
    name: "Lisa",
    rating: 5,
    date: "1 week ago",
    text: "Vincent was very professional and very knowledgeable and tailored my treatment for my needs, with excellent results. I would highly recommend Vincent, definitely going back to see him.",
  },
  {
    name: "Daniel M.",
    rating: 5,
    date: "3 weeks ago",
    text: "Came in with a long-standing shoulder issue. The assessment was thorough and the exercise program actually worked. Pain-free for the first time in months.",
  },
  {
    name: "Priya K.",
    rating: 5,
    date: "1 month ago",
    text: "Genuinely the best physio experience I've had. Clear explanations, no upselling, and a plan that got me back running. Highly recommend Arena Movement.",
  },
];

export const SUCCESS_STORIES = [
  {
    name: "Marathon Return",
    summary: "Patellar tendinopathy → first sub-4 marathon",
    detail: "After 6 months of knee pain, a structured loading program rebuilt strength and confidence to complete a personal-best marathon.",
    before: "Pain on every run, couldn't train",
    after: "Sub-4 hour marathon, pain-free",
    image: IMAGES.athlete,
  },
  {
    name: "Shoulder Reconstruction",
    summary: "Post-op shoulder → back to overhead lifting",
    detail: "A staged post-operative program restored full overhead range and strength, returning to the gym at 5 months.",
    before: "Couldn't lift arm above shoulder",
    after: "Full overhead strength restored",
    image: IMAGES.gymRecovery,
  },
  {
    name: "Chronic Back Pain",
    summary: "Years of back pain → active & confident",
    detail: "Education and a progressive strength program ended a cycle of recurring lower back pain after years of flare-ups.",
    before: "Recurring flare-ups, fear of movement",
    after: "Lifting & active without fear",
    image: IMAGES.legTherapy,
  },
];

export const FAQS = [
  { q: "Do I need a referral to see a physiotherapist?", a: "No. Physiotherapists are primary practitioners, so you can book directly without a GP referral. Referrals are only needed for WorkCover, NDIS or some private health arrangements." },
  { q: "What should I wear to my appointment?", a: "Comfortable clothing you can move in. For lower limb injuries, shorts are helpful; for shoulder or neck, a singlet or loose top works well." },
  { q: "Do you offer private health rebates?", a: "Yes. If you have extras cover for physiotherapy, you can claim on the spot with our HICAPS terminal." },
  { q: "How long is each appointment?", a: "Initial consultations are 45 minutes, follow-ups are 30 minutes, and remedial massage is 20 minutes." },
  { q: "Are physio consultations only on Mondays?", a: "Physiotherapy consultations are currently available on Mondays. Get in touch and we'll find a time that suits you." },
];

export const BLOG = [
  {
    slug: "5-signs-you-should-see-a-physio",
    title: "5 Signs You Should See a Physiotherapist (Not Just Wait It Out)",
    excerpt: "Pain that lingers, recurring niggles, or stiffness that won't budge. Here's how to know when it's time to book in.",
    date: "2026-05-28",
    readTime: "5 min read",
    category: "Injury Prevention",
    image: IMAGES.legTherapy,
    content: [
      "Many people wait far too long before seeing a physiotherapist, hoping that pain or stiffness will simply disappear. Sometimes it does, but often early intervention leads to a faster, more complete recovery.",
      "1. Pain that lasts longer than a week. Most minor strains settle within a few days. If your pain is persisting beyond a week, it's worth getting assessed to rule out anything more significant and to start the right plan.",
      "2. Recurring niggles. If the same injury keeps coming back, there's usually an underlying cause, such as a strength deficit, movement pattern or load issue, that needs addressing.",
      "3. Stiffness that limits your day. Difficulty turning your neck, bending down or reaching overhead is a sign that targeted treatment could restore your movement.",
      "4. Pain that disturbs your sleep. Night pain is a common feature of shoulder and spinal conditions and usually responds well to physiotherapy.",
      "5. You're avoiding activities you love. If you're modifying or skipping the things you enjoy because of pain, that's reason enough to book in.",
      "The bottom line: you don't need a referral to see a physiotherapist. If something doesn't feel right, an early assessment is always worthwhile.",
    ],
  },
  {
    slug: "best-exercises-for-lower-back-pain",
    title: "The Best Exercises for Lower Back Pain (Backed by Evidence)",
    excerpt: "Forget bed rest. Gentle, progressive movement is one of the most effective treatments for most lower back pain.",
    date: "2026-05-15",
    readTime: "6 min read",
    category: "Back Pain",
    image: IMAGES.clinic,
    content: [
      "Lower back pain is incredibly common, with up to 80% of us experiencing it at some point. The good news is that for most people, it isn't dangerous, and movement is medicine.",
      "While these general exercises are a great starting point, the best program is one tailored to you. Here are some safe, evidence-informed movements to begin with.",
      "Cat-Cow: On hands and knees, gently arch and round your spine. This mobilises the spine and eases stiffness.",
      "Glute bridges: Lying on your back with knees bent, lift your hips. This strengthens the glutes and supports the lower back.",
      "Bird-dog: From hands and knees, extend the opposite arm and leg. A fantastic exercise for core control and spinal stability.",
      "Walking: Often underrated, regular walking keeps the spine moving and reduces stiffness and fear of movement.",
      "If your pain is severe, spreading down your leg, or accompanied by numbness or weakness, see a physiotherapist for an individual assessment.",
    ],
  },
  {
    slug: "how-to-prevent-running-injuries",
    title: "How to Prevent Running Injuries: A Physio's Guide",
    excerpt: "Most running injuries come down to one thing: doing too much, too soon. Here's how to train smart and stay healthy.",
    date: "2026-04-30",
    readTime: "7 min read",
    category: "Sports",
    image: IMAGES.athlete,
    content: [
      "Running is one of the best things you can do for your health, but it's also one of the most common sources of overuse injury. The majority of these injuries are preventable.",
      "Respect the 10% rule. As a guide, avoid increasing your weekly running volume by more than about 10% at a time. Sudden spikes in load are the number one cause of running injuries.",
      "Strength train. Two short strength sessions a week, focusing on the calves, glutes and quads, dramatically reduces injury risk and improves performance.",
      "Don't skip recovery. Easy days should be genuinely easy. Sleep, nutrition and rest days are when your body adapts and gets stronger.",
      "Listen to niggles early. A small ache that you address quickly is far easier to manage than an injury you've run through for weeks.",
      "If pain persists for more than a few runs, book in for an assessment. A short course of physiotherapy can keep you running for years to come.",
    ],
  },
];
